import React, { useState, useEffect } from "react";
import Button from "../../Components/Button";
import { supabase } from "../../supabaseClient";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const VendorForm = () => {
  const { id } = useParams();        // UUID
  const navigate = useNavigate();

  const [vendorName, setVendorName] = useState("");
  const [loading, setLoading] = useState(false);

  // -------------------------------
  // Load existing vendor if editing
  // -------------------------------
  useEffect(() => {
    if (id) {
      setLoading(true);
      supabase
        .from("Vendor")
        .select("name")
        .eq("id", id)
        .single()
        .then(({ data, error }) => {
          if (error || !data) {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Failed to load vendor",
              showConfirmButton: false,
              timer: 3000,
              toast: true,
              background: "white",
              customClass: { popup: "shadow-lg rounded-md p-3" },
            });
            navigate("/vendor");
          } else {
            setVendorName(data.name);
          }
          setLoading(false);
        });
    }
  }, [id, navigate]);

  // -------------------------------
  // Save or Update Vendor
  // -------------------------------
  const handleSave = async (e) => {
    e.preventDefault();

    const name = vendorName.trim();
    if (!name) {
      Swal.fire({
        position: "top-end",
        icon: "warning",
        title: "Please enter a vendor name",
        showConfirmButton: false,
        timer: 3000,
        toast: true,
      });
      return;
    }

    setLoading(true);

    // -------- Duplicate Check --------
    const normalized = name.toLowerCase();

   

    // -------- Duplicate Check (100% working) --------
const { data: existingRows, error: fetchErr } = await supabase
  .from("Vendor")
  .select("id, name");

if (fetchErr) {
  setLoading(false);
  Swal.fire({
    position: "top-end",
    icon: "error",
    title: "Something went wrong",
    showConfirmButton: false,
    timer: 3000,
    toast: true,
    background: "white",
    customClass: { popup: "shadow-lg rounded-md p-3" },
  });
  return;
}

const exists = existingRows?.some(
  (row) => row.name.trim().toLowerCase() === name.toLowerCase()
);

// Add mode
if (!id && exists) {
  setLoading(false);
  Swal.fire({
    position: "top-end",
    icon: "error",
    title: `"${name}" already exists`,
    showConfirmButton: false,
    timer: 3000,
    toast: true,
    background: "white",
    customClass: { popup: "shadow-lg rounded-md p-3" },
  });
  return;
}

// Edit mode
if (
  id &&
  existingRows?.some(
    (row) =>
      row.name.trim().toLowerCase() === name.toLowerCase() && row.id !== id
  )
) {
  setLoading(false);
  Swal.fire({
    position: "top-end",
    icon: "error",
    title: `"${name}" already exists`,
    showConfirmButton: false,
    timer: 3000,
    toast: true,
    background: "white",
    customClass: { popup: "shadow-lg rounded-md p-3" },
  });
  return;
}


    // -------------------------------
    // Update
    // -------------------------------
    if (id) {
      const { error } = await supabase
        .from("Vendor")
        .update({ name })
        .eq("id", id);

      setLoading(false);

      if (error) {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Failed to update vendor",
          showConfirmButton: false,
          timer: 3000,
          toast: true,
        });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Vendor updated successfully",
          showConfirmButton: false,
          timer: 3000,
          toast: true,
        });
        navigate("/vendor");
      }
    }

    // -------------------------------
    // Insert
    // -------------------------------
    else {
      const { error } = await supabase
        .from("Vendor")
        .insert([{ name }]);

      setLoading(false);

      if (error) {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Failed to add vendor",
          showConfirmButton: false,
          timer: 3000,
          toast: true,
        });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Vendor added successfully",
          showConfirmButton: false,
          timer: 3000,
          toast: true,
        });
        navigate("/vendor");
      }
    }
  };

  return (
    <div className="min-h-screen flex flex-col p-6 bg-gray-50">
      <div className="mb-6">
        <Button
          variant="secondary"
          className="flex items-center gap-2 px-4 py-2"
          onClick={() => navigate(-1)}
        >
          <span className="text-lg">←</span> Back
        </Button>
      </div>

      <div className="flex-grow flex items-center justify-center">
        <form
          onSubmit={handleSave}
          className="space-y-6 max-w-md w-full bg-white border border-gray-300 rounded-md p-8 shadow-md"
        >
          <h1 className="text-3xl font-bold text-center text-gray-800">
            {id ? "Edit Vendor" : "Add Vendor"}
          </h1>

          <div>
            <label
              htmlFor="vendorName"
              className="block mb-2 font-semibold text-gray-700"
            >
              Enter vendor name
            </label>

            <input
              id="vendorName"
              name="vendorName"
              type="text"
              value={vendorName}
              onChange={(e) => setVendorName(e.target.value)}
              placeholder="Enter vendor name"
              autoFocus
              disabled={loading}
              className="w-full px-4 py-3 border border-gray-300 rounded-md 
                         focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="flex justify-center gap-4">
            <Button
              variant="primary"
              type="submit"
              disabled={loading}
              className="px-8 py-3 font-semibold text-lg"
            >
              {loading ? "Saving..." : id ? "Update" : "Save"}
            </Button>

            <Button
              variant="secondary"
              onClick={() => navigate("/vendor")}
              className="px-8 py-3 font-semibold text-lg"
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VendorForm;
